export enum SamplingPolicy {
  NotSet = 0,
  Measure = 1,
  Diagnostics = 2,
  CriticalBusinessImpact = 191,
  CriticalCensus = 192,
  CriticalExperimentation = 193,
  CriticalUsage = 194
}

export enum PersistencePriority {
  NotSet = 0,
  Normal = 1,
  High = 2
}

export enum CostPriority {
  NotSet = 0,
  Normal = 1,
  High = 2
}

export enum DataCategories {
  NotSet = 0x00,
  SoftwareSetup = 0x01,
  ProductServiceUsage = 0x02,
  ProductServicePerformance = 0x04,
  DeviceConfiguration = 0x08,
  InkingTypingSpeech = 0x10
}

export enum DiagnosticLevel {
  ReservedDoNotUse = 0,
  BasicEvent = 10,
  FullEvent = 100
}
